import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "jQuery imageless buttons a la Google get an update",
  "description": "",
  "published": "2009-07-12T00:00:00.000Z",
  "redirect_from": ["/blog/jquery-imageless-buttons-a-la-google-get-an-update/swizec/622"],
  "categories": "Adobe AIR, JavaScript, jQuery, Uncategorized, Usability",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`That's right, after my `}<a parentName="p" {...{
        "href": "http://swizec.com/code/styledButton/"
      }}>{`jQuery plugin for imageless buttons`}</a>{` much akin to those `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Google",
        "title": "Google"
      }}>{`Google`}</a>{` use in their online apps has been out in the wild for almost six months, an update is now here, making them version ... uhm ... 1.0.3.`}</p>
    <p>{`During this time `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/JQuery",
        "title": "JQuery"
      }}>{`jQuery`}</a>{`.com claims the code to have been downloaded ... well darn, doesn't say anything since I apparently didn't add an actual release. Silly of me. But google analytics claims the page to have been viewed 6222 times, which makes it the single most popular page on this site. Yay.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/code/styledButton"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/07/Picture-1.png",
          "alt": "styledButton screenshot",
          "title": "styledButton screenshot"
        }}></img></a></p>
    <p>{`Nothing much has actually changed except that I fixed a horrible bug, which prevented you from having tagged captions in buttons with dropdowns - this surprisingly took all night to fix, since what you'd normally expect jQuery to do simply melted down and refused to work, yes, even with the latest versions. Aside from that I've also dropped support for `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Safari_%28web_browser%29",
        "title": "Safari (web browser)"
      }}>{`Safari`}</a>{` 2 because updating jQuery to 1.3.x killed everything. It was a surprise to me, but the latest jQuery simply refused to load, `}<em parentName="p">{`nothing`}</em>{` worked.`}</p>
    <p>{`However, if you wish to support the old jQuery this imageless buttons plugin should still work as well as ever, except you won't be able to use tagged captions for dropdowns.`}</p>
    <p>{`That makes the list of supported browsers as follows:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.opera.com",
          "title": "Opera Software"
        }}>{`Opera`}</a>{` 10 beta`}</li>
      <li parentName="ul">{`Opera 9.6x`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Mozilla_Firefox",
          "title": "Mozilla Firefox"
        }}>{`Firefox`}</a>{` 3`}</li>
      <li parentName="ul">{`Firefox 2`}</li>
      <li parentName="ul">{`Safari 4`}</li>
      <li parentName="ul">{`Safari 3`}</li>
      <li parentName="ul">{`Internet Explorer 8 beta`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Internet_Explorer_7",
          "title": "Internet Explorer 7"
        }}>{`Internet Explorer 7`}</a></li>
      <li parentName="ul">{`Internet Explorer 6`}</li>
      <li parentName="ul">{`Chrome`}</li>
      <li parentName="ul">{`Adobe `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Adobe_Integrated_Runtime",
          "title": "Adobe Integrated Runtime"
        }}>{`AIR`}</a>{` 1.5+`}</li>
    </ul>
    <p>{`Which means it should display pixel perfect and the same in all of those, except of course for any differences in parsing fonts.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/5253e1f6-7bed-401a-894a-32b6f23f2734/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=5253e1f6-7bed-401a-894a-32b6f23f2734",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      